import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Combobox, DataListItem, Icon } from '@node-space/ui-components'
import { DarkModeToggle } from 'components/DarkModeToggle'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { useCurrenciesOptions } from '../hooks/useCurrenciesOptions'
import { useCurrency } from '../hooks/useCurrency'
import { useUserCurrentCurrency } from '../hooks/useUserCurrentCurrency'

export const DisplayPreferences = () => {
  const { t } = useTranslation()

  const { profile } = useProfileContext() || {}
  const { language } = profile || {}
  const permissions = useMappedRoles()?.profile
  const canEdit = permissions?.canEdit

  const {
    isCurrencyEditing,
    setCurrency,
    isChangingCurrency,
    handleSaveCurrency,
    setIsCurrencyEditing,
  } = useCurrency()

  const userCurrency = useUserCurrentCurrency()
  const { currencyOptions, isCurrenciesLoading } = useCurrenciesOptions()

  return (
    <Box flexCol gapY={24}>
      <h3 className="text-h3 text-foreground-prominent">{t('account.displayPreferences')}</h3>
      <Box flexCol gapY={16}>
        <DarkModeToggle />
        <DataListItem
          id="language"
          testId="language"
          title={t('language')}
          body={language || 'English'}
          layout="vertical"
        />

        <Box flex gapX={16} className="items-end w-full md:w-auto">
          <Combobox
            disabled={!isCurrencyEditing}
            id="currency"
            testId="currency-combobox"
            loading={isCurrenciesLoading}
            label={t('currency')}
            items={currencyOptions}
            onChange={currency => {
              setCurrency(currency)
            }}
            defaultValue={userCurrency}
          />

          <Button
            variant="primary"
            data-testid="change-currency-button"
            disabled={!canEdit}
            iconElement={<Icon name={isCurrencyEditing ? 'FloppyDisk' : 'SimplePencilCustom'} />}
            loading={isChangingCurrency}
            onClick={() => (isCurrencyEditing ? handleSaveCurrency() : setIsCurrencyEditing(true))}
          >
            {isCurrencyEditing ? t('save') : t('change')}
          </Button>
        </Box>
      </Box>
    </Box>
  )
}
